import * as types from "../actions/ActionTypes";

const defaultPeriod = "a some time";

export const getInitialState = () => (
    {
        expirationPeriod: defaultPeriod,
    });

const linkExpiredReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case types.GET_TICKET_EXPIRATION_PERIOD_SUCCEEDED: {
        return Object.assign({}, state, { expirationPeriod: `${action.expirationPeriod.Value} ${action.expirationPeriod.Units}` });
    }
    case types.GET_TICKET_EXPIRATION_PERIOD_FAILED: {
        return Object.assign({}, state, { expirationPeriod: defaultPeriod });
    }
    default:
        return state;
    }
};

export default linkExpiredReducer;
